import React from "react";
import JsonNode from "./JsonNode";
import { JsonViewerProps } from "./type";
import Expression from "./Expression";
import "./index.css";

export default function JsonViewer(props: JsonViewerProps) {
  const { rootNode, selectedUuid, expression, onSelect, onChangeArrKey } =
    props;
  return (
    <div className="json-viewer">
      <Expression expression={expression}></Expression>
      <div className="json-content">
        <JsonNode
          node={rootNode}
          selectedUuid={selectedUuid}
          onSelect={onSelect}
          onChangeArrKey={onChangeArrKey}
        />
      </div>
    </div>
  );
}
